import React, { useEffect, useState } from 'react';
import moment from 'moment';
import {
  Form,
  Col,
  Row,
  notification,
  Card,
  Input,
  Select,
  DatePicker,
  Popconfirm,
  Button,
  Typography,
  Divider,
} from 'antd';
import Buttonc from 'components/Button';
import  './style.less';
import { useForm } from 'antd/lib/form/Form';
import { useNavigate } from 'react-router-dom';
import DF from 'DisplayFramework';
import ContractListSelect from 'components/ContractListSelect';
import TasksListPopover from '../../workflow/TasksListPopover';
import SaveButton from 'components/SaveButton';
import { useParams } from 'react-router-dom';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import Value from 'components/Value';
import ThirdPartyInput from 'components/ThirdPartyInput';
import DocList from 'pages/Document/DocList';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useQuery } from 'react-query';

import {
  createPayment,
  getPaymentById,
  getWACCPayNettingView,
  updatePayment,
} from 'services/PaymentServices';
import { shouldUpdateCompare, toDatePickerDate } from 'utils/utils2';
import { findCIScheduleByAnyRefOrStatusOrDate } from 'services/clientInvoice';
import { findSISByAnyRefOrStatusOrDate } from 'services/supplierInvoice';
import { toCurrency } from 'utils/utils';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import {
  SearchOutlined,
  PlusOutlined,
  UnorderedListOutlined,
  DeliveredProcedureOutlined,
} from '@ant-design/icons';
import WizardTabs from 'components/WizardTabs';
import NettingList from '../PAYNetting/NettingList';
import ParBankAccountSelect from 'components/ParBankAccountSelect';
import Modal from 'antd/lib/modal/Modal';
import InputCurrency from 'components/InputCurrency';
import DeleteButton from 'components/DeleteButton';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { onFinishFailed } from 'components/DisplayValidationErrors/DisplayValidationErrors';
import Title from 'components/Title';
import UtinaCard from 'components/UtinaCard';
import _, { isNil, sumBy } from 'lodash';
import IActions from 'icons/IActions';
import PayementModal from '../PayementModal';
import ModalControllerNV from 'components/ModalControllerNV';
import { getMyWizards } from 'services/workflow';
import BankAccountListSelect from 'pages/ThirdParty/ThirdPartyDetail/Components/BankAccListSelect';
import AccountingEntryModal from 'pages/Accounting/Components/AccountingEntryModal';
import CIDetail from 'pages/ClientInvoice/CIDetail';
import SIDetail from 'pages/SupplierInvoice/SIDetail';

import { getElementsToDisburse } from 'services/fincontract';
import ProposalModal from 'pages/ProposalV3/ProposalModal';
import ButtonOperation from 'components/ButtonOperation';

type PAYDetailProps = {
  payid?: number;
  hideButtons?: boolean;
  showAsModal?: boolean;
};
const { Option } = Select;
const { Text } = Typography;

const PAYDetail = (props: PAYDetailProps) => {
  let { id } = useParams<{ id: string }>();
  const isCreate = id === 'create';

  const getpayementId = () => {
    const payid = props.payid ? props.payid : id;

    if (isCreate || !payid) {
      return;
    }
    return Number(payid);
  };

  const [refetechnetting, setrefetechnetting] = useState(false);

  const payid = getpayementId();

  const [form] = useForm();

  const navigate = useNavigate();

  let lastFetchId = 0;

  const tabPosition = localStorage.getItem('tabposition');

  const [visible, setVisible] = useState(false);

  const [selectedRowKeysList, setSelectedRowKeysList] = useState<any>();

  let fieldNameNettingList = 'nettingList';

  const {
    data: payement,
    isFetching,
    refetch,
  } = useQuery(
    ['getPaymentById', { payid: Number(payid) }],
    () =>
      getPaymentById({ payid: Number(payid) }).then((res) => {
        if (res.code === '403') {
          history.push('/403');
        }
        return res.data;
      }),
    {
      enabled: !isNil(payid),
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }
  );

  const { data: wizData } = useQuery(['getMyWizards', 'PAYMENT'], () =>
    getMyWizards({ entity: 'PAYMENT' }).then((res) => res.data)
  );

  const [state, setstate] = useState<any>({
    PayNettings: [],
    totalPayNET: 0,
    totalRemaining: 0,
    totalPayAmount: 0,
    payDIR: 'IN',
    taskid: 0,
    listObject: [],
    fetchingObject: false,
    tpreference: '',
    paydueamount: 0,
    ctSearch: '',
    objSearch: '',
    typeSearch: '',
    listOfInvoices: [],
    listOfElements: [],
    listInvoice: [],
    PageTitle: 'New Payment ...',
    isLoading: false,
    searchVisible: false,
    counter: 0,
    selectedRows: [],
    activeKey: '1',
  });

  const [typeSearch, settypeSearch] = useState('');

  const [listObject, setlistObject] = useState<any>([]);

  const [load, setload] = useState(false);
  const [adjust, setadjust] = useState(false);

  const updateAllAmounts = (key: any) => {
    const PayNettings = state.PayNettings;
    let totalPayNet = 0;
    let totalPayNetRemaining = 0;

    for (const i in PayNettings) {
      totalPayNet += PayNettings[i].paynetamount;
      totalPayNetRemaining += PayNettings[i].paynetamount;
    }

    setstate({
      ...state,
      totalPayNET: totalPayNet,
      totalRemaining: totalPayNetRemaining,
      totalPayAmount:
        state.payDIR === 'OUT' ? totalPayNet : state.totalPayAmount,
    });
    if (state.payDIR === 'OUT') {
      form.setFieldsValue({ payamount: totalPayNet });
    }
  };

  const updatePaynet = (key: any, e: any) => {
    // //
    let paynetting2 = state.PayNettings;

    if (state.typeSearch === 'CI') {
      const nettingline = state.listOfInvoices.find(
        (val: any) => val.cisid === e
      );

      let netamount = nettingline.cisdueamount;

      const remaining = state.totalPayAmount - state.totalPayNET;

      if (nettingline.cisdueamount > remaining) {
        netamount = remaining;
      }
      for (const i in paynetting2) {
        if (paynetting2[i].paynetid === key) {
          paynetting2[i].paynetamount = netamount;
          paynetting2[i].maxpaynetamount = netamount;
          paynetting2[i].ciid = nettingline.ciid;
          paynetting2[i].cisid = e;
          paynetting2[i].dueamount = nettingline.cisdueamount;
          paynetting2[i].ctrid = nettingline?.ctrid;
        }
      }
      state.PayNettings = paynetting2;
      form.setFieldsValue({
        [fieldNameNettingList]: paynetting2,
      });
      updateAllAmounts(key);
    } else {
      if (
        state.typeSearch === 'SI' ||
        state.typeSearch === 'WITHTAX' ||
        state.typeSearch === 'HOLDBACK'
      ) {
        const nettingline = state.listOfInvoices.find(
          (val: any) => val.sisid === e
        );

        let netamount = nettingline?.sisdueamount;

        const newPaynet = netamount + state.totalPayNET;
        const newTotalPayment = netamount + state.totalPayAmount;

        for (const i in paynetting2) {
          if (paynetting2[i].paynetid === key) {
            paynetting2[i].paynetamount = netamount;
            paynetting2[i].maxpaynetamount = netamount;
            paynetting2[i].siid = nettingline?.siid;
            paynetting2[i].sisid = e;
            paynetting2[i].maxpaynetamount = netamount;
            paynetting2[i].ctrid = nettingline?.ctrid;
          }
        }
        // let newListInvoice = state.listInvoice;
        // newListInvoice = newListInvoice.filter((inv: any) => inv.value !== e);

        form.setFieldsValue({
          [fieldNameNettingList]: paynetting2,
        });
        setstate({
          ...state,
          PayNettings: paynetting2,
          totalPayNET: newPaynet,
          totalPayAmount: newTotalPayment,
          // listInvoice: newListInvoice,
        });
        form.setFieldsValue({ payamount: newTotalPayment });
      }
    }
  };

  const updatePaynetReim = (key: any, e: any) => {
    const paynetting2 = state.PayNettings;
    const nettingline = state.listOfInvoices.find(
      (val: any) => val.payid === e
    );

    let netamount = nettingline.paynetamount;

    let newlistofInv = state.listOfInvoices;

    let newTotalPayment = netamount + state.totalPayAmount;

    if (nettingline.paynettype === 'WACC' && payid) {
      newlistofInv = newlistofInv
        .map((inv: any) =>
          inv?.payid === e ? { ...inv, paynetamount: 0 } : inv
        )
        .slice();
      netamount =
        nettingline.paynetamount -
        sumBy(
          paynetting2.filter(
            (pay: any) => pay.paynetorder === nettingline.paynetorder
          ),
          'paynetamount'
        );
      newTotalPayment = sumBy(paynetting2, 'paynetamount') + netamount;
    } else if (nettingline.paynettype === 'WACC')
      newlistofInv = newlistofInv
        .map((inv: any) =>
          inv?.payid === e ? { ...inv, paynetamount: 0 } : inv
        )
        .slice();

    const newPaynet = netamount + state.totalPayNET;

    for (const i in paynetting2) {
      if (paynetting2[i].paynetid === key) {
        paynetting2[i].paynetamount = netamount;
        paynetting2[i].payid = nettingline.payid;
        paynetting2[i].payidlinked = e;
        paynetting2[i].maxpaynetamount = netamount;
        paynetting2[i].cisid = e;
        paynetting2[i].ctrid = nettingline?.ctrid;
      }
    }

    form.setFieldsValue({
      [fieldNameNettingList]: paynetting2,
    });
    setstate({
      ...state,
      listOfInvoices: newlistofInv,
      PayNettings: paynetting2,
      totalPayNET: newPaynet,
      totalPayAmount: newTotalPayment,
    });
    form.setFieldsValue({ payamount: newTotalPayment });
  };

  const updatePaynetDISB = (key: any, e: any) => {
    const paynetting2 = state.PayNettings;

    const nettingline = state.listOfElements.find(
      (val: any) => val.cteid === e
    );

    let netamount = nettingline.ctefinancedamount;

    let newlistofElements = state.listOfElements;

    let newTotalPayment = netamount + state.totalPayAmount;

    newlistofElements = newlistofElements
      .map((inv: any) => (inv?.cteid === e ? { ...inv, paynetamount: 0 } : inv))
      .slice();

    const newPaynet = netamount + state.totalPayNET;
    for (const i in paynetting2) {
      if (paynetting2[i].paynetid === key) {
        paynetting2[i].paynetamount = netamount;
        paynetting2[i].payid = nettingline.cteid;
        paynetting2[i].ctrid = nettingline.ctrid;
        paynetting2[i].cteid = e;
        paynetting2[i].maxpaynetamount = netamount;
        paynetting2[i].flagod = true;
      }
    }
    form.setFieldsValue({
      [fieldNameNettingList]: paynetting2,
    });
    setstate({
      ...state,
      listOfElements: newlistofElements,
      PayNettings: paynetting2,
      totalPayNET: newPaynet,
      totalPayAmount: newTotalPayment,
    });
    form.setFieldsValue({ payamount: newTotalPayment });
  };

  const updatePaynetAmount = async (key: any, e: any, el?: any) => {
    const PayNettings = state.PayNettings;
    let linkedInvoice: any;
    // var maxpaynetamount = 0;
    // if (el && el.paynettype === 'REIM')
    //   await getWACCPayNettingView({
    //     tpid: form?.getFieldValue(['thirdparty', 'tpid']),
    //     currcode: form.getFieldValue('currcode'),
    //   }).then((response) => {
    //     maxpaynetamount =
    //       response.list.find((inv: any) => inv.payid === el.payidlinked)
    //         ?.credit + el.paynetamount;
    //   });

    //to check if we can add paymentamount in reim
    let allowaddpayment: any;
    if (state.payDIR === 'OUT') {
      allowaddpayment = true;
    }

    if (state.payDIR === 'IN')
      allowaddpayment =
        sumBy(
          PayNettings?.filter((pay: any) => pay.paynetid !== key),
          'paynetamount'
        ) +
          e <=
        state.totalPayAmount;

    for (const i in PayNettings) {
      if (PayNettings[i].paynetid === key) {
        if (PayNettings[i].paynettype === 'REIM' && allowaddpayment)
          PayNettings[i].paynetamount = e;
        else if (PayNettings[i].paynettype !== 'REIM')
          if (state.payDIR === 'IN' && allowaddpayment)
            PayNettings[i].paynetamount = e;
          else if (state.payDIR === 'IN')
            PayNettings[i].paynetamount =
              state.totalPayAmount -
              sumBy(
                PayNettings?.filter((pay: any) => pay.paynetid !== key),
                'paynetamount'
              );
          else if (state.payDIR === 'OUT') PayNettings[i].paynetamount = e;
        linkedInvoice = PayNettings[i].cisid;
        if (el) {
          PayNettings[i].text = el.objectreference;
          PayNettings[i].ciid = el.ciid;
          PayNettings[i].siid = el.siid;
          PayNettings[i].payidlinked = el.payidlinked;
          PayNettings[i].paynettype = el.paynettype;
          // PayNettings[i].maxpaynetamount =
          //   el.paynettype === 'REIM' ? maxpaynetamount : el.paynetamount;
        }
      }
    }
    let paynetamountotal = 0;
    if (
      state.PayNettings.filter((pay: any) => pay.payid === linkedInvoice)
        .length > 0
    )
      paynetamountotal = sumBy(
        state.PayNettings.filter((pay: any) => pay.payid === linkedInvoice),
        'paynetamount'
      );
    else paynetamountotal = e;
    // state.listOfInvoices = state.listOfInvoices.map((inv: any) =>
    //   inv.payid === linkedInvoice
    //     ? {
    //         ...inv,
    //         paynetamount: inv.initialpayamount - paynetamountotal,
    //       }
    //     : inv
    // );
    form.setFieldsValue({
      [fieldNameNettingList]: PayNettings,
    });
    state.PayNettings = PayNettings;
    updateAllAmounts(key);
  };

  useEffect(() => {
    if (payement) {
      form.setFieldsValue({
        ...payement,
        paydocdate: toDatePickerDate(payement.paydocdate),
        payprocessdate: toDatePickerDate(payement.payprocessdate),
        payduedate: toDatePickerDate(payement.payduedate),
        accountingdate: payement.accountingdate?.substring(0, 10),
        thirdparty: {
          tpid: payement.tpid,
          tpname: payement.tpGeneralData?.tpname,
          tpreference: payement.tpGeneralData?.tpreference,
        },
        bkreconsilationdate: toDatePickerDate(payement.bkreconsilationdate),
      });
      state.PayNettings = payement.payNettings;
      state.tpreference = payement.tpGeneralData?.tpreference;
      state.totalPayAmount = payement.payamount;
      state.payDIR = payement.paydirection;
      state.listInvoice = [];
      payement.payNettings?.forEach((element) => {
        updatePaynetAmount(element.paynetid, element.paynetamount, element);
      });
    }
    form.setFieldsValue({
      paydocdate: form.getFieldValue('paydocdate') ?? moment(),
      payprocessdate: form.getFieldValue('payprocessdate') ?? moment(),
      payduedate: form.getFieldValue('payduedate') ?? moment(),
      bkreconsilationdate:
        form.getFieldValue('bkreconsilationdate') ?? moment(),
    });
  }, [form, payement]);

  useEffect(() => {
    let newList = state.PayNettings;
    form.setFieldsValue({
      [fieldNameNettingList]: newList,
    });
  }, [state.PayNettings]);

  const searchObjectByreference = async (
    objecttype: any,
    objectreference: any,
    ctreference: any
  ) => {
    setload(true);
    lastFetchId += 1;
    const fetchId = lastFetchId;
    state.fetchingObject = true;
    objecttype =
      form.getFieldValue('paydirection') === 'IN'
        ? 'CI'
        : typeSearch === 'REIM'
        ? 'REIM'
        : 'SI';

    if (typeSearch === 'REIM') {
      await getWACCPayNettingView({
        tpid: form.getFieldValue(['thirdparty', 'tpid']),
        currcode: form.getFieldValue('currcode'),
      })
        .then((response) => {
          const listObject = response.list?.map((object: any) => ({
            text: !isNil(object.objectreference)
              ? `${object.paynetreference} - ${object.objectreference} `
              : object.paynetreference,
            value: object.paynetid,
            amount: object.paynetamount,
            dueamount: object.credit,
            duedate: moment(object.paynetdate).format('YYYY-MM-DD'),
            objectreference: !isNil(object.objectreference)
              ? `${object.paynetreference}/${object.objectreference}`
              : object.paynetreference,
            ctreference: object.ctreference,
            operationlabel: object.operationlabel,
            paynettype: object.paynetallocation,
            idparent: object.payid,
            payid: object.payid,
            paynetid: object.paynetid,
            ciid: '',
            cisid: '',
            siid: '',
            sisid: '',
            ciidcreditnote: '',
            siidcreditnote: '',
            currcode: object.currcode,
          }));
          state.listObject = listObject;
          setlistObject(listObject);
          state.fetchingObject = false;
          setload(false);
        })
        .catch(() => {});
    }

    if (objecttype === 'CI' || objecttype === 'CIC') {
      await findCIScheduleByAnyRefOrStatusOrDate({
        cidocreference: '',
        cireference: objectreference,
        cisstatus: '',
        cistype: '',
        clientname: '',
        ctreference: ctreference,
        datemax: '',
        datemin: '',
        mgid: Number(localStorage.getItem('mgid')),
        paystatus: 'PART',
        currcode: form.getFieldValue('currcode'),
        tpreference: state.tpreference,
        tpid: form.getFieldValue(['thirdparty', 'tpid']),
      })
        .then((response) => {
          if (fetchId !== lastFetchId) {
            return;
          }

          const listObject = response.list
            .filter(
              (obj) => obj.cisstatus !== 'INPROG' && obj.cisstatus !== 'PAID'
            )
            .map((object) => ({
              text: `${object.ctreference} - ${object.cireference}/${
                object.cisorder
              } - ${
                localStorage.getItem('lancode') === 'FR'
                  ? 'Montant du remboursement'
                  : 'Rem.Amnt'
              } : ${object.cisdueamount} -  ${
                localStorage.getItem('lancode') === 'FR'
                  ? "Date d'echeance"
                  : 'Due Date'
              } : ${moment(object.cisduedate).format('YYYY-MM-DD')}  `,
              value: object.cisid,
              amount: object.cisamount,
              dueamount: object.cisdueamount,
              duedate: moment(object.cisduedate).format('YYYY-MM-DD'),
              objectreference: `${object.cireference}/${object.cisorder}`,
              ctreference: object.ctreference,
              objecttype: object.citypelabel,
              currcode: object.currcode,
              idparent: object.ciid,
            }));

          state.listObject = listObject;
          setlistObject(listObject);

          state.fetchingObject = false;
          setstate({ ...state });
          setload(false);
        })
        .catch(() => {
          state.listObject = [];
          setload(false);
        });
    }

    if (objecttype === 'SI' || objecttype === 'SIC') {
      await findSISByAnyRefOrStatusOrDate({
        clientname: '',
        ctrreference: ctreference,
        datemax: '',
        datemin: '',
        deliveryreference: '',
        mgid: Number(localStorage.getItem('mgid')),
        orderreference: '',
        paystatus: 'PART',
        sidocreference: '',
        sireference: objectreference,
        sisstatus1: 'TOPAY',
        sisstatus2: 'PART',
        sistype: '',
        suppliername: '',
        tprefclient: state.tpreference,
        tprefsupplier: '',
        tpid: form.getFieldValue(['thirdparty', 'tpid']),
        currcode: form.getFieldValue('currcode'),
      })
        .then((response) => {
          if (fetchId !== lastFetchId) {
            return;
          }

          const listObject = response.list
            .filter((obj) => obj.sisstatus !== 'INPROG')
            .map((object) => ({
              text: `${object.ctreference} - ${object.sireference}/${
                object.sisorder
              } - ${
                localStorage.getItem('lancode') === 'FR'
                  ? 'Montant du remboursement'
                  : 'Rem.Amnt'
              }  : ${object.sisdueamount} -  ${
                localStorage.getItem('lancode') === 'FR'
                  ? "Date d'echeance"
                  : 'Due Date'
              } : ${moment(object.sisduedate).format('YYYY-MM-DD')}  `,
              value: object.sisid,
              amount: object.sisamount,
              dueamount: object.sisdueamount,
              duedate: moment(object.sisduedate).format('YYYY-MM-DD'),
              objectreference: `${object.sireference}/${object.sisorder}`,
              ctreference: object.ctreference,
              objecttype: object.sistype,
              currcode: object.currcode,
              idparent: object.siid,
            }));
          state.listObject = listObject;
          setlistObject(listObject);
          state.fetchingObject = false;
          setload(false);
        })
        .catch(() => {
          state.listObject = [];

          setload(false);
        });
    }
  };

  const onChangePAYNETTYPE = async (key: any, e: any) => {
    // set the selected value in the table

    const PayNettings = state.PayNettings;
    if (e === 'CI' || e === 'SI' || e === 'WITHTAX' || e === 'HOLDBACK') {
      await getInvoice(e);
    }

    if (e === 'REIM') {
      await getAvailableWacc();
    }

    if (e === 'DISB') {
      await getElementToDisburse();
    }

    let remaining = Number(state.totalPayAmount) - Number(state.totalPayNET);
    let totalpaynet = Number(state.totalPayNET);

    for (const i in PayNettings) {
      if (PayNettings[i].paynetid === key) {
        PayNettings[i].paynettype = e;
        PayNettings[i].isnew = false;
        if (
          e !== 'CI' &&
          e !== 'SI' &&
          e !== 'REIM' &&
          e !== 'WITHTAX' &&
          e !== 'HOLDBACK'
        ) {
          PayNettings[i].paynetamount = remaining;
          PayNettings[i].maxpaynetamount = remaining;
          totalpaynet = state.totalPayAmount;
        }
        break;
      }
    }

    form.setFieldsValue({
      [fieldNameNettingList]: PayNettings,
    });

    setstate({
      ...state,
      PayNettings: PayNettings,
      totalPayNET: totalpaynet,
      typeSearch: e,
    });

    state.typeSearch = e;
  };

  const onChangePAYNETALL = (key: any, e: any) => {
    const PayNettings = state.PayNettings;

    for (const i in PayNettings) {
      if (PayNettings[i].paynetid === key) {
        PayNettings[i].paynetallocation = e;
        break;
      }
    }

    setstate({ ...state, PayNettings: PayNettings });
  };

  const onChangeCtridChange = (key: any, e: any) => {
    const PayNettings = state.PayNettings;

    for (const i in PayNettings) {
      if (PayNettings[i].paynetid === key) {
        PayNettings[i].ctrid = e;
        break;
      }
    }
    form.setFieldsValue({
      [fieldNameNettingList]: PayNettings,
    });
    setstate({ ...state, PayNettings: PayNettings });
  };

  const updatetotalPayAmount = (e: any) => {
    state.totalPayAmount = e;
    setstate({ ...state, totalPayAmount: e });
  };

  const handleAddPaynet = () => {
    if (
      Number(state.totalPayAmount) - Number(state.totalPayNET) > 0 ||
      form.getFieldValue('paydirection') === 'OUT'
    ) {
      let PayNettings2 = state.PayNettings;
      const count = Math.floor(_.random(1000000) * 1000000);
      const newData = {
        paynetid: count,
        paynetorder: PayNettings2.length,
        paynetreference: '',
        payid: payid,
        paynetallocation: '',
        payidlinked: 0,
        ctrid: 0,
        ciid: 0,
        ciidcreditnote: '',
        cisid: 0,
        siid: 0,
        siidcreditnote: '',
        sisid: 0,
        cteid: 0,
        paynetamount: 0,
        paynetdate: moment(),
        paynetstatus: 'INIT',
        jobid: 0,
        flagod: false,
        accountingreference: null,
        paynettype: '',
        objectreference: null,
        isnew: true,
      };

      PayNettings2 = [...PayNettings2, newData];

      setstate({ ...state, PayNettings: PayNettings2 });
    } else notification.error({ message: 'No Payement amount to allocate' });
  };

  const handleDeletePaynet = (key: any) => {
    const PayNettings = [...state.PayNettings];
    let deleteline = PayNettings.find((pay: any) => pay.paynetid === key);

    let newlistinvoice = state.listInvoice.filter(
      (item: any) => item.value !== deleteline?.cisid
    );

    let ci = PayNettings.filter((item) => item.paynetid !== key);
    // let newlistOfInvoices = state.listOfInvoices.map((el: any) =>
    //   el.payid === deleteline.payid
    //     ? {
    //         ...el,
    //         paynetamount:
    //           el.initialpayamount -
    //           sumBy(
    //             ci.filter((pay: any) => pay.payid === el.payid),
    //             'paynetamount'
    //           ),
    //       }
    //     : el
    // );

    let newlistOfInvoices = state.listOfInvoices.filter(
      (item: any) => item.cisid !== deleteline?.cisid
    );

    let totalPayNet = 0;
    let totalPayNetRemaining = 0;

    if (ci.length > 0) {
      for (const i in ci) {
        totalPayNet += ci[i].paynetamount;
        totalPayNetRemaining += ci[i].paynetamount;
      }
    } else {
      totalPayNet = 0;
      totalPayNetRemaining = 0;
      // state.totalPayNET = 0;
      // state.totalPayAmount = 0;
    }

    state.PayNettings = ci;

    setstate({
      ...state,
      listInvoice: newlistinvoice,
      PayNettings: ci,
      listOfInvoices: newlistOfInvoices,
      totalPayNET: totalPayNet,
      totalRemaining: totalPayNetRemaining,
      totalPayAmount:
        state.payDIR === 'OUT' ? totalPayNet : state.totalPayAmount,
    });
    if (state.payDIR === 'OUT') {
      form.setFieldsValue({ payamount: totalPayNet });
    }
  };

  const onChangeTypeSearch = async (value: any) => {
    if (value === 'CI' || value === 'SI') {
      await getInvoice(value);
    }

    if (value === 'REIM') {
      await getAvailableWacc();
    }

    setstate({ ...state, typeSearch: value });
  };

  const onChangeOBJSearch = (e: any) => {
    setstate({ ...state, objSearch: e.target.value });
  };

  const onChangeCTSearch = (e: any) => {
    setstate({ ...state, ctSearch: e.target.value });
  };

  const getAvailableWacc = async () => {
    await getWACCPayNettingView({
      tpid: form?.getFieldValue(['thirdparty', 'tpid']),
      currcode: form.getFieldValue('currcode'),
    }).then((response) => {
      if (response.code !== '200') {
        setload(false);
        notification.info({ message: response.message });

        // state.listInvoice = [];
        // state.listOfInvoices = [];
        return;
      }
      const listInvoice = response.list
        .filter(
          (obj) =>
            obj.paynetstatus !== 'USED' &&
            obj.paynetstatus !== 'CANCEL' &&
            obj.paynetamount > 0
        )
        .map((object) => ({
          text: `${object.operationlabel ?? ''} - ${object.payreference} - ${
            object.paynetreference
          } - ${
            localStorage.getItem('lancode') === 'FR'
              ? 'Montant du remboursement'
              : 'Rem.Amnt'
          } : ${toCurrency(
            object.credit,
            object.currcode ?? localStorage.getItem('currcode') ?? ''
          )} `,
          value: object.payid,
          type: 'REIM',
        }));
      state.listInvoice = [
        ...state.listInvoice.filter(
          (inv: any) =>
            listInvoice.find((ninv: any) => inv.value === ninv.value) ===
            undefined
        ),
        ...listInvoice,
      ];
      state.listOfInvoices = response.list.map((inv: any) => ({
        ...inv,
        initialpayamount: payid
          ? inv.paynetamount
          : inv.credit > 0
          ? inv.credit
          : inv.paynetamount,
        paynetamount: state.PayNettings.find(
          (net: any) => net.payid === inv.payid
        )
          ? state.listOfInvoices.find((el: any) => el.payid === inv.payid)
              ?.paynetamount
          : payid
          ? inv.paynetamount
          : inv.credit > 0
          ? inv.credit
          : inv.paynetamount,
      }));

      setload(false);
    });
  };

  const getElementToDisburse = async () => {
    await getElementsToDisburse({
      tpidclient: form?.getFieldValue(['thirdparty', 'tpid']),
      currcode: form.getFieldValue('currcode'),
    }).then((response) => {
      if (response.code !== '200') {
        setload(false);
        notification.info({ message: response.message });

        // state.listInvoice = [];
        // state.listOfInvoices = [];
        return;
      }
      const listOfElements = response.list.map((object) => ({
        text: `${object.ctreference ?? ''} - ${
          object.ctedescription
        } - Fin : ${toCurrency(
          object.ctefinancedamount,
          object.currcode ?? localStorage.getItem('currcode') ?? ''
        )} `,
        value: object.cteid,
        type: 'DISB',
        cteid: object.cteid,
        ctrid: object.ctrid,
        ctefinancedamount: object.ctefinancedamount,
      }));

      state.listOfElements = [
        ...listOfElements.filter(
          (inv: any) =>
            state.PayNettings.find((ninv: any) => inv.cteid === ninv.cteid) ===
            undefined
        ),
        //...listOfElements,
      ];

      setload(false);
    });
  };
  const getInvoice = async (type: string) => {
    setload(true);

    if (type === 'CI') {
      await findCIScheduleByAnyRefOrStatusOrDate({
        cidocreference: '',
        cireference: '',
        cisstatus: '',
        cistype: '',
        clientname: '',
        ctreference: '',
        datemax: '',
        datemin: '',
        mgid: Number(localStorage.getItem('mgid')),
        paystatus: 'PART',
        currcode: form.getFieldValue('currcode'),
        tpreference: state.tpreference,
        tpid: form?.getFieldValue(['thirdparty', 'tpid']),
      }).then((response) => {
        if (response.code !== '200') {
          setload(false);
          notification.info({ message: response.message });

          // state.listInvoice = [];
          // state.listOfInvoices = [];
          return;
        } else {
          // state.listInvoice = [];
          // //
          const listInvoice = response.list
            .filter(
              (obj) =>
                obj.cisstatus !== 'INPROG' &&
                obj.cisstatus !== 'PAID' &&
                obj.cisdueamount > 0 &&
                obj.cidueamount > 0
            )
            .map((object) => ({
              text: `${object.ctreference ?? ''} - ${object.cireference}/${
                object.cisorder
              } - ${
                localStorage.getItem('lancode') === 'FR'
                  ? 'Montant du remboursement'
                  : 'Rem.Amnt'
              }  : ${toCurrency(
                object.cisdueamount,
                object.currcode ?? localStorage.getItem('currcode') ?? ''
              )} - ${
                localStorage.getItem('lancode') === 'FR'
                  ? "Date d'echeance"
                  : 'Due Date'
              } : ${moment(object.cisduedate).format('YYYY-MM-DD')}  `,
              value: object.cisid,
              type: 'CI',
            }));
          state.listInvoice = [
            ...state.listInvoice.filter(
              (inv: any) =>
                listInvoice.find((ninv: any) => inv.value === ninv.value) ===
                undefined
            ),
            ...listInvoice,
          ];
          state.listOfInvoices = response.list.map((inv: any) => ({
            ...inv,
            initialpayamount: payid
              ? inv.paynetamount
              : inv.credit > 0
              ? inv.credit
              : inv.paynetamount,
          }));

          setload(false);
        }
      });
    } else {
      await findSISByAnyRefOrStatusOrDate({
        clientname: '',
        ctrreference: '',
        datemax: '',
        datemin: '',
        deliveryreference: '',
        mgid: Number(localStorage.getItem('mgid')),
        orderreference: '',
        paystatus: 'PART',
        sidocreference: '',
        sireference: '',
        sisstatus1: 'TOPAY',
        sisstatus2: 'PART',
        sistype: type,
        suppliername: '',
        tprefclient: '',
        tprefsupplier: state.tpreference,
        tpid: form?.getFieldValue(['thirdparty', 'tpid']),
        currcode: form.getFieldValue('currcode'),
      }).then((response) => {
        if (response.code !== '200') {
          setload(false);
          notification.info({ message: response.message });
          // state.listInvoice = [];
          // state.listOfInvoices = [];
          return;
        } else {
          const listInvoice = response.list
            .filter(
              (obj) => obj.sisstatus !== 'INPROG' && obj.sisstatus !== 'PAID'
            )
            .map((object) => ({
              text: `${object.ctreference ?? ''} - ${object.sireference}/${
                object.sisorder
              } - ${
                localStorage.getItem('lancode') === 'FR'
                  ? 'Montant du remboursement'
                  : 'Rem.Amnt'
              }  : ${object.sisdueamount} -  ${
                localStorage.getItem('lancode') === 'FR'
                  ? "Date d'echeance"
                  : 'Due Date'
              } : ${moment(object.sisduedate).format('YYYY-MM-DD')}  `,

              value: object.sisid,
              type: type,
            }));

          state.listInvoice = [
            ...state.listInvoice.filter(
              (inv: any) =>
                listInvoice.find((ninv: any) => inv.value === ninv.value) ===
                undefined
            ),
            ...listInvoice,
          ];
          state.listOfInvoices = response.list.map((inv: any) => ({
            ...inv,
            initialpayamount: payid
              ? inv.paynetamount
              : inv.credit > 0
              ? inv.credit
              : inv.paynetamount,
          }));

          setload(false);
        }
      });
    }
  };

  const reset = () => {
    state.PayNettings = [];
    state.totalPayNET = 0;
    state.totalRemaining = 0;
    state.totalPayAmount = form.getFieldValue('payamount');
    state.payDIR = 'IN';
    state.taskid = 0;
    state.listObject = [];
    state.fetchingObject = false;
    state.tpreference = '';
    state.paydueamount = 0;
    state.ctSearch = '';
    state.objSearch = '';
    state.typeSearch = '';
    state.listOfInvoices = [];
    state.listInvoice = [];
    state.PageTitle = 'New Payment ...';
    state.isLoading = false;
    state.searchVisible = false;
    state.counter = 0;
    state.selectedRows = [];
    state.activeKey = '1';
  };

  const adjustDebit = async (amount: any) => {
    if (form.getFieldValue('paydirection') === 'IN' && amount > 0) {
      getInvoice('CI');

      await findCIScheduleByAnyRefOrStatusOrDate({
        cidocreference: '',
        cireference: '',
        cisstatus: '',
        cistype: '',
        clientname: '',
        ctreference: '',
        datemax: '',
        datemin: '',
        mgid: Number(localStorage.getItem('mgid')),
        paystatus: 'PART',
        currcode: form.getFieldValue('currcode'),
        tpreference: state.tpreference,
        tpid: form.getFieldValue(['thirdparty', 'tpid']),
      }).then((response) => {
        if (response.code !== '200') {
          setadjust(false);
          notification.error({
            message: 'No data found',
          });
          return;
        }
        if (response.list.length > 0) {
          const listObject = response.list
            .filter(
              (obj) => obj.cisstatus !== 'INPROG' && obj.cisstatus !== 'CANCEL'
            )
            .map((object) => ({
              text: `${object.ctreference} - ${object.cireference}/${
                object.cisorder
              } - ${
                localStorage.getItem('lancode') === 'FR'
                  ? 'Montant du remboursement'
                  : 'Rem.Amnt'
              }  : ${object.cisdueamount} -  ${
                localStorage.getItem('lancode') === 'FR'
                  ? "Date d'echeance"
                  : 'Due Date'
              } : ${moment(object.cisduedate).format('YYYY-MM-DD')}  `,
              value: object.cisid,
              amount: object.cisamount,
              dueamount: object.cisdueamount,
              duedate: moment(object.cisduedate).format('YYYY-MM-DD'),
              objectreference: `${object.cireference}/${object.cisorder}`,
              ctreference: object.ctreference,
              objecttype: object.citypelabel,
              idparent: object.ciid,
              paynettype: 'CI',
            }));

          state.listObject = listObject;
          state.fetchingObject = false;

          AddadjustDebitRow(amount);
        }
      });
    } else setadjust(false);
  };
  const [loadingBtn, setLoadingBtn] = useState<boolean>(false);
  const validate = (values: any) => {
    form.validateFields().then((values) => {
      if (
        (
          Number(form.getFieldValue('payamount')?.toFixed(2)) -
          Number(
            _.sumBy(form.getFieldValue(fieldNameNettingList), 'paynetamount')
          )
        ).toFixed(2) !== '0.00'
      ) {
        notification.error({
          message: 'Error validating input ',
          description: `The total Payment and Total Allocation are different. (${String(
            toCurrency(
              Number(state.totalPayAmount) - Number(state.totalPayNET),
              form.getFieldValue('currcode')
            )
          )}) please put the difference in a waiting account(${String(
            Number(state.totalPayAmount)
          )}) // (${String(Number(state.totalPayNET))})`,
        });
        return;
      }

      if (state.totalPayAmount === 0) {
        notification.error({
          message: 'Error validating input',
          description: `The total Payment must be > 0 (${String(
            Number(state.totalPayAmount)
          )}) // (${String(Number(state.totalPayNET))})`,
        });
        return;
      }
      let remaining = 0;
      // const PayNettings2 = state.PayNettings;

      const header = {
        payid: payid ?? 0,
        payreference: form.getFieldValue('payreference'),
        paydirection: state.payDIR,
        paytype: 'PAY',
        paymode: values.paymode,
        paystatus: 'INIT',
        tpid: values.thirdparty.tpid,
        mgid: Number(localStorage.getItem('mgid')),
        paydocreference: values.paydocreference,
        paydocdate: values.paydocdate,
        paydate: values.paydocdate,
        payduedate: values.paydocdate,
        payprocessdate: values.paydocdate,
        currcode: values.currcode,
        payamount: state.totalPayAmount,
        payremainingamount: values.payremainingamount ?? 0,
        paytpbankaccount: values.paytpbankaccount,
        paymgbankaccount: values.paymgbankaccount,
        payrejected: false,
        payidreject: 0,
        payrejectreason: '',
        payrejectdate: '',
        payrejectfeesamount: 0,
        accountingreference: '',
        accountingdate: '',
        jobid: 0,
        tpbkid: form.getFieldValue('tpbkid'),
        last_action: payid
          ? wizData?.taskidUpdate ?? 0
          : wizData?.taskidCreate ?? 0,
        bkreconsiliationref:
          values.bkreconsiliationref === '' ? null : values.bkreconsiliationref,
        bkreconsilationdate: values.bkreconsilationdate ?? null,
      };

      let payNettings: any[] = [];

      state.PayNettings.forEach((sch: any) => {
        if (sch.paynetamount > 0) {
          payNettings.push({
            cteid: sch.cteid,
            paynetid: sch.paynetid,
            paynetorder: sch.paynetorder,
            payid: state.payid,
            paynettype: sch.paynettype,
            paynetallocation:
              sch.paynettype === 'WACC' ? sch.paynetallocation : '',
            payidlinked: sch.payidlinked,
            ctrid: sch.ctrid,
            ciid: sch.ciid,
            ciidcreditnote: sch.ciidcreditnote,
            cisid: sch.cisid,
            siid: sch.siid,
            siidcreditnote: sch.siidcreditnote,
            sisid: sch.sisid,
            paynetamount: sch.paynetamount,
            paynetdate: sch.paynetdate,
            paynetstatus: 'INIT',
            jobid: 0,
            flagod: sch.flagod,
            accountingreference: '',
          });
        }
      });

      const paymentRequest = { ...header, payNettings };
      const paymentRequestC = {
        payid: payid ?? 0,
        payreference: form.getFieldValue('payreference'),
        paydirection: form.getFieldValue('paydirection') ?? state.payDIR,
        paytype: 'PAY',
        paymode: values.paymode,
        paystatus: 'INIT',
        tpid: values.thirdparty.tpid,
        mgid: Number(localStorage.getItem('mgid')),
        paydocreference: values.paydocreference,
        paydocdate: values.paydocdate ?? moment().format('YYYY-MM-DD'),
        paydate: values.paydocdate ?? moment().format('YYYY-MM-DD'),
        payduedate: values.payduedate ?? moment().format('YYYY-MM-DD'),
        payprocessdate: values.paydocdate ?? moment().format('YYYY-MM-DD'),
        currcode: values.currcode,
        payamount: state.totalPayAmount,
        payremainingamount: remaining,
        paytpbankaccount: values.paytpbankaccount,
        paymgbankaccount: values.paymgbankaccount,
        payrejected: false,
        payidreject: 0,
        payrejectreason: '',
        payrejectdate: '',
        payrejectfeesamount: 0,
        accountingreference: '',
        accountingdate: '',
        jobid: 0,
        tpbkid: form.getFieldValue('tpbkid'),
        payNettings: payNettings,
        last_action: payid
          ? wizData?.taskidUpdate ?? 0
          : wizData?.taskidCreate ?? 0,
        bkreconsiliationref:
          values.bkreconsiliationref === '' ? null : values.bkreconsiliationref,
        bkreconsilationdate: values.bkreconsilationdate ?? null,
      };

      state.displayTabUpload = true;
      if (!payid) {
        setLoadingBtn(true);
        createPayment({ jobid: 0, paymentRequest: paymentRequestC! })
          .then((response) => {
            setLoadingBtn(false);
            let l_status;
            l_status = response.code;
            if (l_status != null && Number(l_status) !== 200) {
              if (Number(l_status) === 417) {
                notification.error({
                  message: `Functional Controls : Insert was not performed because of following Controls : ${response.description}`,
                  description: response.message,
                  duration: 0,
                });
                setLoadingBtn(false);
              } else {
                setLoadingBtn(false);
                notification.error({
                  message: `Error : ${response.code}`,
                  description: `${response.description} ${response.message}`,
                  duration: 0,
                });
              }
            } else {
              navigate(`/payment/${response.data.payid}`);

              notification.success({
                message: response.message,
                description: '',
                duration: 10,
              });
              setLoadingBtn(false);
            }
          })
          .catch((err) => {
            setLoadingBtn(false);
            if (err.status === 417) {
              let l_table = '';
              const msgview = JSON.parse(err.message);
              let i = 0;
              msgview.forEach((msg: any) => {
                i++;
                l_table =
                  `${l_table}<tr><td>${i}. ${msg.ccode} - ` +
                  `</td><td>${msg.message}</td></tr>`;
              });

              const ll_table = document.createElement('table');
              ll_table.innerHTML = l_table;
              ll_table.innerHTML = ll_table.textContent!;

              const l_message = (
                <html>
                  <div style={{ color: 'green' }}>
                    <table>
                      <tr>{ll_table.innerHTML}</tr>
                    </table>
                  </div>
                </html>
              );

              notification.error({
                message:
                  'Error creating Client Invoice because of following Functional controls :',
                description: l_message,
                duration: 0,
              });
            }
          });
      } else {
        setLoadingBtn(true);
        updatePayment({
          payid: paymentRequest.payid,
          paymentRequest: paymentRequest,
        })
          .then((response) => {
            setLoadingBtn(false);
            let l_status;
            l_status = response.code;
            if (l_status != null && Number(l_status) !== 200) {
              if (Number(l_status) === 417) {
                notification.error({
                  message: `Functional Controls : Insert was not performed because of following Controls : ${response.code}`,
                  description: response.message,
                  duration: 0,
                });
                setLoadingBtn(false);
              } else {
                notification.error({
                  message: `Error : ${response.code}`,
                  description: `${response.description} ${response.message}`,
                  duration: 0,
                });
                setLoadingBtn(false);
              }
            } else {
              navigate(`/payment/${response.data.payid}`);

              notification.success({
                message: 'Payment updated successfully',
                description: '',
                duration: 10,
              });
              setLoadingBtn(false);
            }
          })
          .catch((err) => {
            setLoadingBtn(false);
            if (err.status === 417) {
              let l_table = '';
              const msgview = JSON.parse(err.message);
              let i = 0;
              msgview.forEach((msg: any) => {
                i++;
                l_table =
                  `${l_table}<tr><td>${i}. ${msg.ccode} - ` +
                  `</td><td>${msg.message}</td></tr>`;
              });

              const ll_table = document.createElement('table');
              ll_table.innerHTML = l_table;
              ll_table.innerHTML = ll_table.textContent!;

              const l_message = (
                <html>
                  <div style={{ color: 'green' }}>
                    <table>
                      <tr>{ll_table.innerHTML}</tr>
                    </table>
                  </div>
                </html>
              );

              notification.error({
                message:
                  'Error updating Payment because of following Functional controls :',
                description: l_message,
                duration: 0,
              });
            }
          });
      }
    });
  };

  const handleSearch = async () => {
    state.searchVisible = true;
    // setlistObject([]);
    state.listObject = [];

    let cilist: any[] = state.PayNettings.map((item: any) => item.cisid);
    let silist: any[] = state.PayNettings.map((item: any) => item.sisid);
    let rmlist: any[] = state.PayNettings.map((item: any) => item.paynetid);

    let newlist = [];
    newlist = [...cilist, ...silist, ...rmlist];

    setSelectedRowKeysList(newlist);

    if (typeSearch === 'CI' || typeSearch === 'SI') {
      await getInvoice(typeSearch);
    }

    if (typeSearch === 'REIM') {
      await getAvailableWacc();
    }

    searchObjectByreference(state.typeSearch, state.objSearch, state.ctSearch);
  };

  const closeSearch = () => {
    setstate({
      ...state,
      objSearch: '',
      ctSearch: '',
      typeSearch: '',
    });
  };

  const AddadjustDebitRow = (amount: any) => {
    const listObject2 = state.listObject;
    const firstAmount = amount;
    let PayNettings2 = state.PayNettings;
    let count = PayNettings2[PayNettings2?.length - 1]?.paynetid ?? 0;
    let tst = 0;
    let ciid = '';
    let cisid = '';
    let siid = '';
    let sisid = '';
    for (var i = state.counter; i < listObject2.length; i++) {
      if (amount === 0) {
        state.counter = i;
        break;
      } else if (amount < listObject2[i].dueamount) {
        const val = listObject2[i].value;
        tst = PayNettings2.findIndex((item: any) => item.cisid === val);

        if (tst < 0) {
          count = Math.floor(_.random(1000000) * 1000000);
          const newData = {
            paynetid: count,
            paynetorder: i,
            paynetreference: '',
            payid: payid,
            paynetallocation: listObject2[i].text,
            payidlinked: null,
            ctrid: null,
            ciid: listObject2[i].idparent,
            ciidcreditnote: null,
            cisid: listObject2[i].value,
            siid,
            siidcreditnote: null,
            sisid,
            paynetamount: amount,
            dueamount: listObject2[i].dueamount,
            paynetdate: moment(),
            paynetstatus: 'INIT',
            jobid: 0,
            flagod: false,
            accountingreference: null,
            paynettype: listObject2[i].paynettype,
            objectreference: listObject2[i].text,
            auto: true,
          };

          PayNettings2 = [...PayNettings2, newData];
          amount = 0;
          state.counter = i;
        }
      } else {
        const val = listObject2[i].value;
        tst = PayNettings2.findIndex((item: any) => item.cisid === val);

        if (tst < 0 && listObject2[i].dueamount > 0) {
          let nettingamount = listObject2[i].dueamount;
          if (amount < nettingamount) {
            nettingamount = amount;
          }
          amount -= Number(nettingamount);

          if (nettingamount > 0) {
            count += 1;
            const newData = {
              paynetid: count,
              paynetorder: i,
              paynetreference: '',
              payid: payid,
              paynetallocation: listObject2[i].text,
              payidlinked: null,
              ctrid: null,
              ciid: listObject2[i].idparent,
              ciidcreditnote: null,
              cisid: listObject2[i].value,
              siid,
              siidcreditnote: null,
              sisid,
              paynetamount: nettingamount,
              dueamount: listObject2[i].dueamount,
              paynetdate: moment(),
              paynetstatus: 'INIT',
              jobid: 0,
              flagod: false,
              accountingreference: null,
              paynettype: listObject2[i].paynettype,
              objectreference: listObject2[i].text,
              auto: true,
            };
            PayNettings2 = [...PayNettings2, newData];
          }
          state.counter = i;
        }
      }
    }

    if (amount > 0 && state.counter === listObject2.length - 1) {
      if (
        PayNettings2.find((net: any) => net.paynettype === 'WACC') === undefined
      ) {
        count = Math.floor(_.random(10000) * 1000000);
        const newData = {
          paynetid: Math.floor(_.random(10000) * 1000000),
          paynetorder: i,
          paynetreference: '',
          payid: payid,
          paynetallocation: null,
          payidlinked: null,
          ctrid: null,
          ciid,
          ciidcreditnote: null,
          cisid,
          siid,
          siidcreditnote: null,
          sisid,
          paynetamount: firstAmount - sumBy(PayNettings2, 'paynetamount'),
          paynetdate: moment(),
          paynetstatus: 'INIT',
          jobid: 0,
          flagod: false,
          accountingreference: null,
          paynettype: 'WACC',
          objectreference: '',
          auto: true,
        };
        PayNettings2 = [...PayNettings2, newData];
      } else {
        const index = PayNettings2.findIndex(
          (net: any) => net.paynettype === 'WACC'
        );
        PayNettings2[index]!.paynetamount =
          PayNettings2[index]!.paynetamount + amount;
        PayNettings2 = [...PayNettings2];
      }
      amount = 0;
    }
    state.PayNettings = PayNettings2;

    let totalPayNet = 0;
    let totalPayNetRemaining = 0;

    for (var j in PayNettings2) {
      totalPayNet += PayNettings2[j].paynetamount;
      totalPayNetRemaining += PayNettings2[j].paynetamount;
    }

    state.totalPayNET = _.floor(totalPayNet, 5);
    state.totalRemaining = totalPayNetRemaining;
    setstate({ ...state });
    if (state.payDIR === 'OUT') {
      state.totalPayAmount = totalPayNet;
    }
    setadjust(false);
  };

  const validateSearch = () => {
    let filteredList = state.selectedRows;
    let newlistofInv = state.listOfInvoices;

    let PayNettings2 = state.PayNettings;

    let count = Math.floor(_.random(100000) * 1000000);
    let testAlreadylused = 0;
    let remaining = state.totalPayAmount - state.totalPayNET;
    let difference: any = [];

    for (const j in filteredList) {
      let ciid = '';
      let cisid = '';
      let siid = '';
      let sisid = '';
      let payal = '';
      let payid = '';

      if (typeSearch === 'CI') {
        cisid = filteredList[j].value;
        ciid = filteredList[j].idparent;
        payal = filteredList[j].text;
        const val = filteredList[j].value;
        testAlreadylused = PayNettings2.findIndex(
          (item: any) => item.cisid === val
        );
      }

      if (typeSearch === 'SI') {
        sisid = filteredList[j].value;
        siid = filteredList[j].idparent;
        const val = filteredList[j].value;
        testAlreadylused = PayNettings2.findIndex(
          (item: any) => item.sisid === val
        );
      }

      if (typeSearch === 'REIM') {
        const val = filteredList[j].payid;
        payid = filteredList[j].payid;
        testAlreadylused = PayNettings2.findIndex(
          (item: any) => item.payid === val
        );
      }

      if (testAlreadylused < 0) {
        count += 1;
        let netamount = filteredList[j].dueamount;
        if (netamount > remaining) {
          netamount = remaining;
        }
        remaining = remaining - netamount;

        if (netamount > 0 || typeSearch === 'SI' || typeSearch === 'REIM') {
          const newData = {
            paynetid: typeSearch === 'REIM' ? filteredList[j].paynetid : count,
            paynetorder: Number(j),
            paynetreference: '',
            payid: payid,
            paynetallocation: payal,
            payidlinked: payid,
            ctrid: null,
            ciid,
            ciidcreditnote: null,
            cisid,
            siid,
            siidcreditnote: null,
            sisid,
            paynetamount:
              typeSearch === 'SI' || typeSearch === 'REIM'
                ? filteredList[j].dueamount
                : netamount,
            paydueamount:
              typeSearch === 'SI' || typeSearch === 'REIM'
                ? filteredList[j].dueamount
                : netamount,
            dueamount: filteredList[j].dueamount,
            paynetdate: moment(),
            paynetstatus: 'INIT',
            jobid: 0,
            flagod: false,
            accountingreference: null,
            paynettype: typeSearch,
            objectreference: filteredList[j].text,
          };

          PayNettings2 = [...PayNettings2, newData];
        }
      }
    }

    let newList = PayNettings2.map((a: any) => a.payid);

    newlistofInv = newlistofInv.map((inv: any) =>
      newList.includes(inv?.payid) ? { ...inv, paynetamount: 0 } : inv
    );

    state.listOfInvoices = newlistofInv;

    state.PayNettings = PayNettings2;

    let totalPayNet = 0;
    let totalPayNetRemaining = 0;

    for (var j in PayNettings2) {
      totalPayNet += PayNettings2[j].paynetamount;
      totalPayNetRemaining += PayNettings2[j].paynetamount;
    }

    state.totalPayNET = totalPayNet;
    state.totalRemaining = totalPayNetRemaining;

    if (state.payDIR === 'OUT') {
      state.totalPayAmount = totalPayNet;
    }

    // state.selectedRows = state.PayNettings.map((item: any) => item.cisid);

    if (typeSearch === 'CI') {
      difference = PayNettings2.filter(
        (obj1: any) =>
          !filteredList.find((obj2: any) => obj1.cisid === obj2.value)
      );
    }

    if (typeSearch === 'SI') {
      difference = PayNettings2.filter(
        (obj1: any) =>
          !filteredList.find((obj2: any) => obj1.sisid === obj2.value)
      );
    }

    if (typeSearch === 'REIM') {
      difference = PayNettings2.filter(
        (obj1: any) =>
          !filteredList.find((obj2: any) => obj1.payid === obj2.payid)
      );
    }

    difference.forEach((x: any) => {
      if (x.paynettype === typeSearch) {
        handleDeletePaynet(x.paynetid);
      }
    });

    if (PayNettings2 === 0) {
      state.totalPayNET = 0;
    }

    setstate({ ...state });
    closeSearch();
  };

  const onSelectChange = (selectedRowKeys: any, selectedRows: any) => {
    setSelectedRowKeysList(selectedRowKeys);
    setstate({ ...state, selectedRows: selectedRows });
  };

  const columnsPayNetting: DataGridColDef<any>[] = [
    {
      dataIndex: 'paynettype',
      key: 'paynettype',
      width: '120px',
      render: (text, record) => (
        <ParListSelect
          parcode="PAYNETTYPE"
          parvalueparent={form.getFieldValue('paydirection')}
          defaultValue={record.paynettype}
          disabled={
            (payement?.paydirection === 'OUT' && !isNil(payid)) ||
            record.paynettype !== ''
          }
          onChange={(e) => {
            onChangePAYNETTYPE(record.paynetid, e);
          }}
        />
      ),
    },
    {
      dataIndex: 'paynetallocation',
      key: 'paynetallocation',
      width: '300px',
      render: (text, record) => {
        return (
          ((record.paynettype === 'WACC' ||
            record.paynettype === 'DEPOSIT') && (
            <Row>
              <Col span={8}>
                <ParListSelect
                  parcode={
                    record.paynettype === 'WACC' ? 'PAYNETALL' : 'DEPOSIT'
                  }
                  defaultValue={record.paynetallocation}
                  onChange={(e) => {
                    onChangePAYNETALL(record.paynetid, e);
                  }}
                />
              </Col>
              <Col span={4}>
                <Text type="warning" strong>
                  &nbsp;&nbsp;&nbsp;Contract ? :
                </Text>
              </Col>
              <Col span={12}>
                <ContractListSelect
                  tpreference={form.getFieldValue([
                    'thirdparty',
                    'tpreference',
                  ])}
                  allowClear
                  value={record.ctrid}
                  onChange={(e) => {
                    onChangeCtridChange(record.paynetid, e);
                  }}
                />
              </Col>
            </Row>
          )) ||
          ((record.paynettype === 'CI' ||
            record.paynettype === 'SI' ||
            record.paynettype === 'WITHTAX' ||
            record.paynettype === 'HOLDBACK') &&
            (state.listInvoice.find(
              (inv: any) =>
                inv.value === record.cisid || inv.value === record.sisid
            ) === undefined && !record?.text ? (
              <Select
                onChange={(e) => {
                  updatePaynet(record?.paynetid, e);
                }}
                loading={load}
                value={record.cisid === 0 ? '' : record.cisid}
                disabled={record?.auto === true}
                showSearch
              >
                {state.listInvoice
                  .filter(
                    (inv: any) =>
                      state.PayNettings.find(
                        (val: any) =>
                          val.cisid === inv.value || val.sisid === inv.value
                      ) === undefined && inv.type === record.paynettype
                  )
                  .map((d: any, index: number) => {
                    return (
                      <Option key={d.value} value={d.value}>
                        {d.text}
                      </Option>
                    );
                  })}
              </Select>
            ) : state.listInvoice.find(
                (inv: any) =>
                  inv.value === record.cisid || inv.value === record.sisid
              )?.text ? (
              <Value
                value={
                  state.listInvoice.find(
                    (inv: any) =>
                      inv.value === record.cisid || inv.value === record.sisid
                  )?.text
                }
              />
            ) : record.paynettype === 'CI' ? (
              <ModalControllerNV
                modal={({ setVisible, visible }) => (
                  <CIDetail
                    ciid={record.ciid}
                    onCancel={() => setVisible(false)}
                    showAsModal
                    visible={visible}
                    showButtons={false}
                  />
                )}
                content={({ setVisible, visible }) => (
                  <a onClick={() => setVisible(true)}>{record.text}</a>
                )}
              />
            ) : (
              <ModalControllerNV
                content={({ setVisible, visible }) => (
                  <a
                    onClick={() => {
                      setVisible(true);
                    }}
                  >
                    {record.text}
                  </a>
                )}
                modal={({ setVisible, visible }) => (
                  <SIDetail
                    siid={record.siid}
                    onCancel={() => setVisible(false)}
                    showAsModal
                    visible={visible}
                    showButtons={false}
                  />
                )}
              />
            ))) ||
          (record.paynettype === 'REIM' &&
            (state.listInvoice.find(
              (inv: any) => inv.value === record.payid
            ) === undefined && !record?.text ? (
              <Select
                onChange={(e) => updatePaynetReim(record.paynetid, e)}
                disabled={record?.auto === true}
              >
                {state.listInvoice
                  .filter(
                    (inv: any) =>
                      state.listOfInvoices.find(
                        (el: any) => el.payid === inv.value
                      )?.paynetamount > 0 && inv.type === record.paynettype
                    // state.PayNettings.find(
                    //   (val: any) => val.cisid === inv.value
                    // ) === undefined
                  )
                  .map((d: any) => (
                    <Option key={d.value} value={d.value}>
                      {d.text}
                    </Option>
                  ))}
              </Select>
            ) : !isNil(record?.payidlinked) ? (
              <ModalControllerNV
                modal={({ setVisible, visible }) => (
                  <PayementModal
                    payid={record?.payidlinked}
                    showAsModal
                    visible={visible}
                    onCancel={() => setVisible(false)}
                    onSuccess={() => setVisible(false)}
                  />
                )}
                content={({ setVisible, visible }) => (
                  <a
                    onClick={() => {
                      setVisible(true);
                    }}
                  >
                    {state.listInvoice.find(
                      (inv: any) => inv.value === record.payid
                    )?.text ?? record.text}
                  </a>
                )}
              />
            ) : (
              <Value
                value={
                  state.listInvoice.find(
                    (inv: any) => inv.value === record.cisid
                  )?.text ?? record.text
                }
              />
            ))) ||
          (record.paynettype === 'DISB' &&
            (isNil(payid) ? (
              <Select
                onChange={(e) => updatePaynetDISB(record.paynetid, e)}
                disabled={record?.auto === true}
              >
                {state.listOfElements.map((d: any) => (
                  <Option key={d.value} value={d.value}>
                    {d.text}
                  </Option>
                ))}
              </Select>
            ) : (
              <ModalControllerNV
                modal={({ setVisible, visible }) => (
                  <ProposalModal
                    ctrid={record.ctrid}
                    visible={visible}
                    onCancel={() => setVisible(false)}
                    onSuccess={() => setVisible(false)}
                    title=""
                    phase="PROD"
                    iscreate={false}
                  />
                )}
                content={({ setVisible, visible }) => (
                  <a onClick={() => setVisible(true)}>
                    {record.objectreference}
                  </a>
                )}
              />
            )))
        );
      },
    },

    {
      dataIndex: 'paynetamount',
      key: 'paynetamount',
      width: '150px',

      render: (text, record) => {
        return (
          <InputCurrency
            currcode={form.getFieldValue('currcode')}
            value={record.paynetamount}
            onChange={(e) => {
              updatePaynetAmount(record.paynetid, e);
            }}
            disabled={
              (record.cisid === 0 && !record.maxpaynetamount) ||
              (payement?.paydirection === 'OUT' && !isNil(payid)) ||
              payement?.paystatus === 'INIT' ||
              record.paynettype === 'DISB'
            }
            min={0}
            max={
              record.paynettype === 'CI'
                ? record.dueamount
                : record.paynettype === 'REIM' || record.paynettype === 'SI'
                ? record.maxpaynetamount
                  ? record.maxpaynetamount
                  : record.paydueamount
                : false
            }
          />
        );
      },
    },

    {
      dataIndex: 'operation',
      render: (text, record, index) =>
        state.PayNettings.length >= 1 ? (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDeletePaynet(record.paynetid)}
            disabled={payement?.paystatus === 'INIT'}
          >
            <DeleteButton onlyIcon />
          </Popconfirm>
        ) : null,
      fixed: 'right',
      width: '80px',
    },
  ];

  const columnsSearch: DataGridColDef<any>[] = [
    {
      dataIndex: 'objectreference',
      width: '150px',
      fixed: 'left',
    },
    {
      dataIndex: 'ctreference',
      width: '120px',
    },
    {
      dataIndex: 'objecttype',
      width: '150px',
      align: 'left',
    },
    {
      dataIndex: 'amount',
      width: '100px',
      align: 'right',
      render: (value, record) => toCurrency(value, record.currcode),
    },
    {
      dataIndex: 'dueamount',
      width: '100px',
      align: 'right',
      render: (value, record) => toCurrency(value, record.currcode),
    },
    {
      dataIndex: 'duedate',
      width: '100px',
      align: 'right',
    },
  ];
  // const { listObject, fetchingObject, valueObject } = state;

  const actionsSI = (
    <div>
      <Row>
        <Col span={payid ? 16 : 20}>
          {' '}
          <div style={{ fontSize: '14px', fontWeight: 'bold' }}>
            {!props.showAsModal && (
              <ArrowLeftOutlined
                onClick={() => {
                  navigate(`/payment`);
                }}
                style={{
                  float: 'left',
                  margin: '0px 5px',
                  fontSize: 'larger',
                }}
              />
            )}
            {payid ? (
              <>
                <GetLabel label="payement" />
                {' - '}
                {payement?.payreference +
                  ' - ' +
                  payement?.tpGeneralData?.tpname}
              </>
            ) : (
              <Title level={4} comcode="NewPayment"></Title>
            )}
          </div>
        </Col>

        <Col span={payid ? 8 : 4}>
          <Row gutter={2} justify="end">
            {isNil(payid) ? (
              <Col span={19}>
                <SaveButton
                  comcode="Save"
                  custom={{ height: 52 }}
                  loading={loadingBtn}
                />
              </Col>
            ) : !props.hideButtons ? (
              payement?.paystatus === 'INIT' &&
              payement?.paydirection !== 'OUT' ? (
                <>
                  <Col span={5}>
                    <TasksListPopover
                      entityId={payid}
                      entityReference={payement?.payreference}
                      entityName="PAYMENT"
                      onClose={() => {
                        refetch();
                        setrefetechnetting(!refetechnetting);
                      }}
                    >
                      <Buttonc
                        comcode="actions"
                        style={{ width: 120, height: 52 }}
                        icon={<IActions />}
                      />
                    </TasksListPopover>
                  </Col>
                  <Col span={4}>
                    <SaveButton
                      comcode="Save"
                      custom={{ height: 52 }}
                      loading={loadingBtn || isFetching}
                    />
                  </Col>
                </>
              ) : (
                <Col span={6} style={{ textAlign: 'right' }}>
                  <TasksListPopover
                    entityId={payid}
                    entityReference={payement?.payreference}
                    entityName="PAYMENT"
                    onClose={() => {
                      refetch();
                      setrefetechnetting(!refetechnetting);
                    }}
                  >
                    <Buttonc
                      comcode="actions"
                      style={{ width: 120, height: 52 }}
                      icon={<IActions />}
                    />
                  </TasksListPopover>
                </Col>
              )
            ) : null}
          </Row>
        </Col>
      </Row>
    </div>
  );
  const { loading, selectedRowKeys, PayNettings } = state;

  const rowSelection = {
    selectedRowKeys: selectedRowKeysList,
    onChange: onSelectChange,
  };

  return (
    <DF.Provider pagcode="paymentdetail" entity="PAYMENT" entityid={payid || 0}>
      <Form
        layout="vertical"
        form={form}
        hideRequiredMark
        onFinish={validate}
        onFinishFailed={onFinishFailed}
      >
        {tabPosition === 'left' ? actionsSI : null}

        <WizardTabs
          entity="PAYMENT"
          entityid={payid || 1}
          taskid={
            payid ? wizData?.taskidDisplay ?? 0 : wizData?.taskidCreate ?? 0
          }
          defaultTabs={['tabPayment']}
          tabBarExtraContent={tabPosition === 'top' ? actionsSI : null}
          tabs={{
            tabPayNetting: (
              <Card className={'card'} bordered>
                <Row gutter={16}>
                  <Col span={24}>
                    {!payid || payement?.paystatus === 'INIT' ? (
                      <div>
                        <Row>
                          {payement?.paystatus !== 'INIT' && (
                            <Col span={8}>
                              <Button
                                onClick={handleAddPaynet}
                                type="primary"
                                disabled={
                                  state.PayNettings?.find(
                                    (pay: any) => pay?.paynetamount === 0
                                  ) ||
                                  (form.getFieldValue('thirdparty') ===
                                    undefined &&
                                    (false ||
                                      (payement?.paystatus === 'INIT' &&
                                        state.totalPayAmount !== 0 &&
                                        Number(state.totalPayAmount) -
                                          Number(state.totalPayNET) ===
                                          0))) ||
                                  form.getFieldValue('thirdparty') === undefined
                                }
                                icon={<PlusOutlined />}
                                style={{
                                  marginBottom: 0,
                                }}
                              >
                                <GetLabel label="AddLine" />
                              </Button>

                              <Button
                                onClick={() => {
                                  handleSearch();
                                  setVisible(true);
                                }}
                                type="primary"
                                style={{ marginLeft: 10 }}
                                icon={<UnorderedListOutlined />}
                                disabled={
                                  state.PayNettings?.find(
                                    (pay: any) => pay?.paynetamount === 0
                                  ) ||
                                  form.getFieldValue('thirdparty') ===
                                    undefined ||
                                  (payement?.paystatus === 'INIT' &&
                                    state.totalPayAmount !== 0 &&
                                    Number(
                                      form
                                        .getFieldValue('payamount')
                                        ?.toFixed(3)
                                    ) -
                                      Number(
                                        _.sumBy(
                                          form.getFieldValue(
                                            fieldNameNettingList
                                          ),
                                          'paynetamount'
                                        )
                                      ) ===
                                      0)
                                }
                              >
                                <GetLabel label="MultipleSelection" />
                              </Button>
                            </Col>
                          )}

                          <Col span={8}>
                            <Form.Item noStyle shouldUpdate>
                              {({ getFieldValue }) => {
                                return (
                                  <Text strong style={{ color: 'blue' }}>
                                    <GetLabel label="PaymentAmount" />:{' '}
                                    {toCurrency(
                                      getFieldValue('payamount'),
                                      form.getFieldValue('currcode') ??
                                        localStorage.getItem('currcode') ??
                                        ''
                                    )}
                                  </Text>
                                );
                              }}
                            </Form.Item>
                            <br />

                            <Form.Item noStyle shouldUpdate>
                              {({ getFieldValue }) => {
                                return (
                                  <Text strong style={{ color: 'red' }}>
                                    <GetLabel label="TotalAllocated" /> :{' '}
                                    {toCurrency(
                                      _.sumBy(
                                        getFieldValue(fieldNameNettingList),
                                        'paynetamount'
                                      ),
                                      form.getFieldValue('currcode') ??
                                        localStorage.getItem('currcode') ??
                                        ''
                                    )}
                                  </Text>
                                );
                              }}
                            </Form.Item>
                            <br />

                            <Form.Item noStyle shouldUpdate>
                              {({ getFieldValue }) => {
                                return (
                                  getFieldValue('paydirection') !== 'OUT' && (
                                    <Text
                                      strong
                                      style={{
                                        color:
                                          Number(
                                            getFieldValue('payamount')?.toFixed(
                                              3
                                            )
                                          ) -
                                            Number(
                                              _.sumBy(
                                                getFieldValue(
                                                  fieldNameNettingList
                                                ),
                                                'paynetamount'
                                              )
                                            ) !==
                                          0
                                            ? 'red'
                                            : 'darkgreen',
                                      }}
                                    >
                                      <GetLabel label="NotAllocated" /> :
                                      {toCurrency(
                                        Number(
                                          getFieldValue('payamount')?.toFixed(3)
                                        ) -
                                          Number(
                                            _.sumBy(
                                              getFieldValue(
                                                fieldNameNettingList
                                              ),
                                              'paynetamount'
                                            )
                                          ),
                                        form.getFieldValue('currcode') ??
                                          localStorage.getItem('currcode') ??
                                          ''
                                      )}
                                    </Text>
                                  )
                                );
                              }}
                            </Form.Item>
                            <br />
                          </Col>
                          {payement?.paystatus !== 'INIT' && (
                            <Col span={8} style={{ textAlign: 'right' }}>
                              <ButtonOperation
                                type="primary"
                                style={{ marginLeft: 10 }}
                                icon={<DeliveredProcedureOutlined />}
                                onClick={(e) => {
                                  reset();
                                  e.stopPropagation();
                                  setadjust(true);
                                  adjustDebit(state.totalPayAmount);
                                }}
                                disabled={
                                  adjust ||
                                  state.payDIR === 'OUT' ||
                                  (payement?.paystatus === 'INIT' &&
                                    state.totalPayAmount !== 0 &&
                                    Number(state.totalPayAmount) -
                                      Number(state.totalPayNET) ===
                                      0)
                                }
                                loading={adjust}
                                comcode="Adjust (Waterfall rules)"
                              />
                            </Col>
                          )}
                        </Row>
                        <Form.Item shouldUpdate>
                          {({ getFieldValue }) => {
                            return (
                              <DataGrid
                                size="small"
                                isLoading={adjust}
                                scroll={{ x: 1000, y: 400 }}
                                pagination={{ pageSize: 100, responsive: true }}
                                dataSource={getFieldValue(fieldNameNettingList)}
                                columns={
                                  payement?.paystatus === 'INIT'
                                    ? columnsPayNetting.filter(
                                        (item) => item.dataIndex !== 'operation'
                                      )
                                    : columnsPayNetting
                                }
                                rowKey={(record) => record.paynetid}
                              />
                            );
                          }}
                        </Form.Item>
                      </div>
                    ) : (
                      <div>
                        <Row>
                          <Col span={4}>
                            <GetLabel label="payamount" />
                          </Col>
                          <Text strong style={{ color: '#389e0d' }}>
                            {toCurrency(
                              Number(form.getFieldValue('payamount')),
                              form.getFieldValue('currcode') ??
                                localStorage.getItem('currcode') ??
                                ''
                            )}
                          </Text>
                          <Col span={1} />
                          <Col span={4}>
                            <GetLabel label="payremainingamount" />
                          </Col>

                          <Text strong style={{ color: '#389e0d' }}>
                            {toCurrency(
                              Number(form.getFieldValue('payremainingamount')),
                              form.getFieldValue('currcode') ??
                                localStorage.getItem('currcode') ??
                                ''
                            )}
                          </Text>
                        </Row>
                        <NettingList
                          refetchNetting={refetechnetting}
                          hideExtraAction
                          hideFilters
                          objectid={payid}
                          objecttype="PAYMENT"
                        />
                      </div>
                    )}
                  </Col>
                </Row>
              </Card>
            ),
            tabPayment: (
              <Card
                className={'card'}
                title={<GetLabel label="General Data" />}
                type="inner"
                bordered
              >
                <Row gutter={32}>
                  <Col xl={{ span: 4 }}>
                    <FormInput name="payreference">
                      <Input disabled />
                    </FormInput>
                  </Col>
                  <Col xl={{ span: 4 }}>
                    <Form.Item name="refrejet" label="Rej?">
                      <a style={{ color: 'blue' }}>
                        {form.getFieldValue('payrejected') ? 'Yes' : 'No'}
                      </a>
                    </Form.Item>
                  </Col>

                  <Col xl={{ span: 5 }}>
                    <FormInput
                      name="paydirection"
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <ParListSelect
                        parcode="PAYFDIR"
                        style={{ width: '100%' }}
                        disabled={!!payid}
                        onChange={(val) => {
                          form.setFieldsValue({
                            payamount: 0,
                            payremainingamount: 0,
                            paymode: val === 'IN' ? 'DDEBIT' : 'TRANSFER',
                            paymgbankaccount: '',
                          });
                          settypeSearch(val === 'IN' ? 'CI' : 'SI');
                          setstate({
                            ...state,
                            payDIR: val,
                            typeSearch: val === 'IN' ? 'CI' : 'SI',
                            PayNettings: [],
                            listOfInvoices: [],
                            listInvoice: [],
                            counter: 0,
                            totalPayNET: 0,
                            totalPayAmount: 0,
                          });
                        }}
                      />
                    </FormInput>
                  </Col>
                  <FormInput col xl={4} name="statuslabel">
                    <Value />
                  </FormInput>
                </Row>
                <Row>
                  <UtinaCard
                    level={5}
                    comcode="general_info"
                    style={{ color: '#000', marginLeft: 20, paddingTop: 20 }}
                    lg={17}
                  >
                    <Row gutter={16}>
                      <Col xl={{ span: 6 }}>
                        <Form.Item
                          shouldUpdate={shouldUpdateCompare('paydirection')}
                        >
                          {({ getFieldValue }) => {
                            return (
                              <FormInput
                                name="paymode"
                                rules={[
                                  {
                                    required: true,
                                    message: 'This field is mandatory',
                                  },
                                ]}
                              >
                                {payid !== undefined ? (
                                  getFieldValue('paydirection') === 'IN' ? (
                                    <ParListSelect
                                      style={{ width: '100%' }}
                                      parcode="PAYMODEIN"
                                      value={state.paymod}
                                      disabled={
                                        state.paymod !== '' &&
                                        payement?.paystatus !== 'INIT'
                                      }
                                    />
                                  ) : (
                                    <ParListSelect
                                      style={{ width: '100%' }}
                                      parcode="PAYMODEOUT"
                                      value={state.paymod}
                                      disabled={
                                        state.paymod !== '' &&
                                        payement?.paystatus !== 'INIT'
                                      }
                                    />
                                  )
                                ) : getFieldValue('paydirection') === 'IN' ? (
                                  <ParListSelect
                                    style={{ width: '100%' }}
                                    parcode="PAYMODEIN"
                                  />
                                ) : (
                                  <ParListSelect
                                    style={{ width: '100%' }}
                                    parcode="PAYMODEOUT"
                                  />
                                )}
                              </FormInput>
                            );
                          }}
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <FormInput
                          name="paydocreference"
                          rules={[
                            {
                              required: true,
                              message: 'This field is mandatory',
                            },
                          ]}
                        >
                          <Input />
                        </FormInput>
                      </Col>
                      <Col xl={{ span: 8 }} lg={{ span: 4 }} md={8} sm={24}>
                        <FormInput
                          name="thirdparty"
                          rules={[
                            {
                              required: true,
                              message: 'This field is mandatory',
                            },
                          ]}
                        >
                          <ThirdPartyInput
                            role=""
                            onChange={() => {
                              form.setFieldsValue({
                                payamount: 0,
                                payremainingamount: 0,
                                tpbkid: '' as any,
                              });
                              setstate({
                                ...state,
                                PayNettings: [],
                                listOfInvoices: [],
                                listInvoice: [],
                                counter: 0,
                                totalPayNET: 0,
                                totalPayAmount: 0,
                              });
                            }}
                            display={
                              (payement?.paydirection === 'OUT' &&
                                !isNil(payid)) ||
                              payement?.paystatus === 'INIT'
                            }
                          />
                        </FormInput>
                      </Col>
                      <Col span={4}>
                        <FormInput name="currcode" shouldUpdate>
                          <ParListSelect
                            parcode="CURRENCY"
                            onSelected={(e) => {
                              form.setFieldsValue({
                                payamount: 0,
                                payremainingamount: 0,
                              });
                              setstate({
                                ...state,
                                PayNettings: [],
                                listOfInvoices: [],
                                counter: 0,
                                listInvoice: [],
                                totalPayNET: 0,
                                totalPayAmount: 0,
                              });
                            }}
                            disabled={
                              (payement?.paydirection === 'OUT' &&
                                !isNil(payid)) ||
                              payement?.paystatus === 'INIT'
                            }
                          />
                        </FormInput>
                      </Col>

                      <Col xl={{ span: 6 }} lg={{ span: 4 }} md={12} sm={24}>
                        <Form.Item
                          noStyle
                          shouldUpdate={shouldUpdateCompare([
                            'thirdparty',
                            'paydirection',
                          ])}
                        >
                          {({ getFieldValue }) => {
                            return (
                              <FormInput name="tpbkid">
                                <BankAccountListSelect
                                  params={{
                                    tpid: getFieldValue('thirdparty')?.tpid,
                                    allowedBktype: [
                                      getFieldValue('paydirection'),
                                      'INOUT',
                                    ],
                                  }}
                                />
                              </FormInput>
                            );
                          }}
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item
                          noStyle
                          shouldUpdate={shouldUpdateCompare([
                            'paydirection',
                            'currcode',
                          ])}
                        >
                          {({ getFieldValue }) => {
                            return (
                              <FormInput name="paymgbankaccount">
                                <ParBankAccountSelect
                                  mgid={Number(localStorage.getItem('mgid'))}
                                  direction={getFieldValue('paydirection')}
                                  currcode={getFieldValue('currcode')}
                                />
                              </FormInput>
                            );
                          }}
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <FormInput name="paydocdate">
                          <DatePicker />
                        </FormInput>
                      </Col>
                      <Col span={6}>
                        <FormInput name="payduedate">
                          <DatePicker />
                        </FormInput>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={6}>
                        <FormInput name="payprocessdate">
                          <DatePicker disabled />
                        </FormInput>
                      </Col>
                      <Col md={{ span: 6 }}>
                        <FormInput name="accountingreference">
                          <Text type="warning">
                            <AccountingEntryModal
                              accountingReference={form.getFieldValue(
                                'accountingreference'
                              )}
                            />
                          </Text>
                        </FormInput>
                      </Col>
                      <Col md={6}>
                        <FormInput name="accountingdate">
                          <Text>{form?.getFieldValue('accountingdate')} </Text>
                        </FormInput>
                      </Col>

                      <Col span={6}>
                        <FormInput name="bkreconsilationdate">
                          <DatePicker />
                        </FormInput>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={6}>
                        <FormInput name="bkreconsiliationref">
                          <Input />
                        </FormInput>
                      </Col>
                    </Row>
                  </UtinaCard>
                  <UtinaCard
                    level={5}
                    comcode="financial_info"
                    style={{ color: '#000', marginLeft: 20, paddingTop: 20 }}
                    lg={5}
                  >
                    <Row gutter={[8, 8]}>
                      <Col xl={{ span: 24 }}>
                        <Form.Item
                          noStyle
                          shouldUpdate={shouldUpdateCompare('currcode')}
                        >
                          {({ getFieldValue }) => {
                            return (
                              <FormInput name="payamount">
                                <InputCurrency
                                  currcode={getFieldValue('currcode')}
                                  onChange={(e) => {
                                    updatetotalPayAmount(e);
                                    setstate({
                                      ...state,
                                      PayNettings: [],
                                      listOfInvoices: [],
                                      counter: 0,
                                      listInvoice: [],
                                      totalPayNET: 0,
                                    });
                                  }}
                                  disabled={
                                    getFieldValue('paydirection') === 'OUT' ||
                                    payement?.paystatus === 'INIT'
                                  }
                                />
                              </FormInput>
                            );
                          }}
                        </Form.Item>
                      </Col>
                      <Col xl={{ span: 12 }}></Col>

                      <Col xl={{ span: 24 }}>
                        <FormInput name="payremainingamount">
                          <Text strong type="danger">
                            {toCurrency(
                              Number(form.getFieldValue('payremainingamount')),
                              form.getFieldValue('currcode') ??
                                localStorage.getItem('currcode') ??
                                ''
                            )}
                          </Text>
                        </FormInput>
                      </Col>
                    </Row>
                  </UtinaCard>
                </Row>
                <Row>
                  {form?.getFieldValue('paystatus') === 'REJECT' && (
                    <UtinaCard
                      level={5}
                      comcode="Rejection_info"
                      style={{ color: '#000', marginLeft: 20, paddingTop: 20 }}
                      lg={14}
                    >
                      <Row gutter={32}>
                        <Col lg={{ span: 6 }}>
                          <FormInput name="payrejectdate">
                            <Text disabled>
                              {moment(
                                form.getFieldValue('payrejectdate')
                              ).format('YYYY-MM-DD')}
                            </Text>
                          </FormInput>
                        </Col>
                        <Col lg={{ span: 6 }}>
                          <FormInput name="payrejectreasonLabel">
                            <Text disabled>
                              {form.getFieldValue('payrejectreasonLabel')}
                            </Text>
                          </FormInput>
                        </Col>

                        <Col lg={{ span: 6 }}>
                          <FormInput name="refrejet">
                            <ModalControllerNV
                              modal={({ setVisible, visible }) => (
                                <PayementModal
                                  payid={form.getFieldValue('payidreject')}
                                  showAsModal
                                  hideButtons
                                  visible={visible}
                                  onCancel={() => setVisible(false)}
                                  onSuccess={() => setVisible(false)}
                                />
                              )}
                              content={({ setVisible, visible }) => (
                                <a onClick={() => setVisible(true)}>
                                  {form.getFieldValue('refrejet')}
                                </a>
                              )}
                            />
                          </FormInput>
                        </Col>
                      </Row>
                    </UtinaCard>
                  )}
                  {form?.getFieldValue('paystatus') === 'REPR' && (
                    <>
                      <UtinaCard
                        level={5}
                        comcode="Rejection_info"
                        style={{
                          color: '#000',
                          marginLeft: 20,
                          paddingTop: 20,
                        }}
                        lg={14}
                      >
                        <Row gutter={32}>
                          <Col lg={{ span: 6 }}>
                            <FormInput name="payrejectdate">
                              <Text disabled>
                                {moment(
                                  form.getFieldValue('payrejectdate')
                                ).format('YYYY-MM-DD')}
                              </Text>
                            </FormInput>
                          </Col>
                          <Col lg={{ span: 6 }}>
                            <FormInput name="payrejectreasonLabel">
                              <Text disabled>
                                {form.getFieldValue('payrejectreasonLabel')}
                              </Text>
                            </FormInput>
                          </Col>

                          <Col lg={{ span: 6 }}>
                            <FormInput name="refrejet">
                              <Text>{form.getFieldValue('refrejet')}</Text>
                            </FormInput>
                          </Col>
                        </Row>
                      </UtinaCard>
                      <UtinaCard
                        level={5}
                        comcode="Represented_info"
                        style={{
                          color: '#000',
                          marginLeft: 20,
                          paddingTop: 20,
                        }}
                        lg={8}
                      >
                        <Row gutter={32}>
                          <Col lg={{ span: 6 }}>
                            <FormInput name="paynbrepresentation">
                              <Text>
                                {form.getFieldValue('paynbrepresentation')}
                              </Text>
                            </FormInput>
                          </Col>
                          <Col lg={{ span: 6 }}>
                            <FormInput name="paydaterepresentation">
                              <Text>
                                {form.getFieldValue('paydaterepresentation')}
                              </Text>
                            </FormInput>
                          </Col>

                          <Col lg={{ span: 6 }}>
                            <FormInput name="payrefrepresentation">
                              <ModalControllerNV
                                modal={({ setVisible, visible }) => (
                                  <PayementModal
                                    payid={form.getFieldValue(
                                      'payidrepresented'
                                    )}
                                    showAsModal
                                    hideButtons
                                    visible={visible}
                                    onCancel={() => setVisible(false)}
                                    onSuccess={() => setVisible(false)}
                                  />
                                )}
                                content={({ setVisible, visible }) => (
                                  <a
                                    onClick={() => {
                                      form.getFieldValue('payidrepresented') !=
                                        null && setVisible(true);
                                    }}
                                  >
                                    {form.getFieldValue('payrefrepresentation')}
                                  </a>
                                )}
                              />
                            </FormInput>
                          </Col>
                        </Row>
                      </UtinaCard>
                    </>
                  )}
                </Row>
              </Card>
            ),
            tabPaymentUpload: (
              <DocList objectid={payid} objecttype="PAYMENT" categorie="DOC" />
            ),
          }}
        />
      </Form>
      <Modal
        visible={visible}
        title={<GetLabel label="MultiSelect" />}
        destroyOnClose
        footer={[
          <Button
            key="Cancel"
            onClick={() => {
              closeSearch();
              setVisible(false);
            }}
          >
            Cancel
          </Button>,
          <Button
            key="Validate"
            type="primary"
            loading={loading}
            onClick={() => {
              validateSearch();
              setVisible(false);
            }}
          >
            Validate
          </Button>,
        ]}
        onCancel={() => {
          closeSearch();
          setVisible(false);
        }}
        width="1200px"
        style={{ top: 20, right: 0 }}
      >
        <div>
          <Row>
            <Col>
              <Text strong>Type#</Text>
            </Col>
            <Col span={1} />
            <Col>
              <Form.Item shouldUpdate={shouldUpdateCompare('paydirection')}>
                <ParListSelect
                  style={{ width: '160px' }}
                  parcode="PAYNET"
                  value={typeSearch}
                  parvalueparent={form.getFieldValue('paydirection')}
                  onSelected={(e) => {
                    onChangeTypeSearch(e);
                    settypeSearch(e);
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={1} />
            <Col>
              <Text strong>Contract Ref#</Text>
            </Col>
            <Col span={1} />
            <Col>
              <Input
                style={{ width: '120px' }}
                onChange={onChangeCTSearch}
                allowClear
                disabled={typeSearch === 'REIM'}
              />
            </Col>
            <Col span={1} />
            <Col>
              <Text strong>Invoice Ref#</Text>
            </Col>
            <Col span={1} />
            <Col>
              <Input
                style={{ width: '120px' }}
                onChange={onChangeOBJSearch}
                allowClear
                disabled={typeSearch === 'REIM'}
              />
            </Col>
            <Col span={2} />
            <Col>
              {' '}
              <Button
                type="primary"
                style={{ width: 150 }}
                icon={<SearchOutlined />}
                onClick={(e) => {
                  searchObjectByreference(
                    state.typeSearch,
                    state.objSearch,
                    state.ctSearch
                  );
                }}
              >
                {' '}
                Search
              </Button>
            </Col>
            <Divider />
          </Row>
          <Row>
            <DataGrid
              size="small"
              scroll={{ x: 700, y: 500 }}
              pagination={{ pageSize: 100 }}
              bordered
              rowSelection={rowSelection}
              dataSource={listObject}
              columns={columnsSearch}
              rowKey={(record) => record.value}
              isLoading={load}
            />
          </Row>
        </div>
      </Modal>
    </DF.Provider>
  );
};

export default PAYDetail;
